// ----------------------------------------------------------------------

export type User = {
  id: number;
  name: string;
  username: string;
  email: string;
  is_superuser?: boolean;
  role: UserRole;
  is_beta_user?: boolean;
};

export enum UserRole {
  ADMIN = "admin",
  BRANDANALYST = "brand_analyst",
  USER = "user",
  BETAUSER = "beta_user",
  TESTER = "tester",
}

export type ActionMap<M extends { [index: string]: any }> = {
  [Key in keyof M]: M[Key] extends undefined
    ? {
        type: Key;
      }
    : {
        type: Key;
        payload: M[Key];
      };
};

export type AuthUser = null | User;

export type AuthState = {
  isAuthenticated: boolean;
  isInitialized: boolean;
  confirmedEmail?: string;
  user: AuthUser;
};

export type AuthContextType = {
  isAuthenticated: boolean;
  isInitialized: boolean;
  user: AuthUser;
  login: (email: string, password: string) => Promise<unknown>;
  register: (
    email: string,
    password: string,
    firstName: string,
    recaptchaToken: string,
    priceId: string,
    referralCode?: string,
  ) => Promise<unknown>;
  logout: VoidFunction;
  forgotPassword: (email: string) => Promise<unknown>;
  resetPassword: (validationCode: string, password: string) => Promise<unknown>;
  changePassword: (
    currentPassword: string,
    newPassword: string,
  ) => Promise<unknown>;
};
